import React, {useState, useEffect, useCallback} from 'react';
import TextField from '@material-ui/core/TextField';
import {FormControl, IconButton, InputAdornment, Link} from "@material-ui/core";
import useMapboxVerify from "../../../../hooks/useMapboxVerify";


const AddressTextField = ({onAction, Icon, addressInfo, disableSuggestion, ...props}) => {
    const {verify} = useMapboxVerify();
    const [value, setValue] = useState(props.value);
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);


    const handleChange = (event) => {
        setValue(event.target.value);
        setUpdated(true);
    }

    const handleClick = async (event) => {
        const addressText = `${value}, ${formatAddressInfo()}`;
        let address = await verify(addressText);

        if (!address.valid) {
            address = await verify(`${value}, ${addressInfo.country}`);
        }

        onAction(address);
    }

    const formatAddressInfo = () => {
        const addressData = [addressInfo.city, addressInfo.state, addressInfo.country, addressInfo.postCode];
        return addressData.join(",");
    }

    return (
        <FormControl fullWidth>
            <TextField
                {...props}
                value={value}
                onChange={handleChange}
                disabled={props.disabled}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton
                            aria-label="go to site"
                            edge="end"
                            onClick={handleClick}
                            disabled={props.disabled || disableSuggestion}
                        >
                            {
                                !props.disabled && updated ? <Link>
                                    <Icon />
                                </Link> : <Icon />
                            }

                        </IconButton>
                    </InputAdornment>
                }}
            />
        </FormControl>
    );
}

export default AddressTextField;